import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import {
  GenericExportDialogComponent,
  GenericExportDialogConfig,
} from '@tv3/shared/dialogs/generic-export-dialog/generic-export-dialog.component'
import * as R from 'ramda'
import * as moment from 'moment'
import { Rental } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class DownloadInquiriesDialogService {
  constructor(private dialog: MatDialog) {}

  private getConfig(data: Inquiry[], filename: string): GenericExportDialogConfig {
    return {
      title: $localize`Download Inquiries to CSV`,
      description: $localize`You are about to download all inquiries within your current filter.`,
      columns: [
        { name: $localize`Source`, field: 'inquirySource' },
        { name: $localize`Rental`, field: 'rentalView' },
        { name: $localize`Updated`, field: 'touchView' },
        { name: $localize`Guest Name`, field: 'guestNameView' },
        { name: $localize`Arrive`, field: 'arriveView' },
        { name: $localize`Depart`, field: 'departView' },
        { name: $localize`Nights`, field: 'nightsView' },
        { name: $localize`Guests`, field: 'guestsView' },
      ],
      exportData: data,
      filename: filename,
      columnCustomizable: true,
    }
  }

  open(inquiries: Inquiry[], filters: any, rentals: Rental[]) {
    const monthsList = moment.months().map((name, id) => ({ id, name }))
    const month = R.find((m) => m.id === filters?.month, monthsList) || { name: 'All' }
    const source = filters?.source || 'All'
    const status = filters?.status || 'All'
    const rentalNames =
      R.pipe(
        R.filter((r: Rental) => R.contains(r.id, filters?.rentals || [])),
        <any>R.map((r: Rental) => r.name),
        R.join(',')
      )(<any>rentals) || 'All'

    const filename = `Inquiries_Month(${
      month.name
    })_Source(${source})_Status(${status})_Rentals(${rentalNames})_Date(${moment().format('MM_DD_YYYY')})`

    const defaultConfig: MatDialogConfig = {
      width: '900px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        config: this.getConfig(inquiries, filename),
      },
    }

    return this.dialog.open(GenericExportDialogComponent, defaultConfig)
  }
}
